/** The site-wide Open Graph splash image, served from `static/assets/`. */
export const SOCIAL_IMAGE = {
  url: "https://modal.com/assets/social-image-5.jpg",
  width: 1200,
  height: 630,
  alt: "Modal: The platform for production AI",
};
